module.exports = __webpack_public_path__ + "img/img_app_bnr_02_feature1.44173770.png";